
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ide-praktik/bukti-karya",
      function () {
        return require("private-next-pages/ide-praktik/bukti-karya.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ide-praktik/bukti-karya"])
      });
    }
  